jQuery(function($) {

	const header = $('#header');
	const footer = $('#footer');
	const root = document.documentElement;

	function getCookie(cName) {
	      const name = cName + "=";
	      const cDecoded = decodeURIComponent(document.cookie); //to be careful
	      const cArr = cDecoded .split('; ');
	      let res;
	      cArr.forEach(val => {
	          if (val.indexOf(name) === 0) res = val.substring(name.length);
	      })
	      return res;
	}

	$(document).ready(function() {

		if ( window.location.search ) {
			$('.query-var-link, .query-var-link a').each( function(index, element) {
				var href = $(this).attr('href');
				if ( href ) {
					$(this).attr('href', href + window.location.search);
				}
			});
		}

		

		function calcHeaderHeight() {
			var stickyHeight = header.outerHeight();
			root.style.setProperty('--header-height', stickyHeight + 'px');
			$('body').addClass('has-header-height');

			var footerHeight = footer.outerHeight();
			root.style.setProperty('--footer-height', footerHeight + 'px');
		}

		function calcHeights() {
			calcHeaderHeight();
		}

		calcHeights();

		window.addEventListener( 'resize', calcHeights );		

		$('.menu-toggle').click( function(e) {
		  $('body').toggleClass('menu-open');
		});

		$('.faq-question').click( function(e) {
			$(this).parents('.faq').toggleClass('active');
			$(this).next('.answer').toggle('fast');
		});

		$('h3').on('click', $('.accordion-item:not(.active)'), function(e) {
			$(this).parents('.accordion').find('.accordion-item').removeClass('active');
			$(this).parents('.accordion-item').addClass('active');
		});

		AOS.init({
			// Global settings:
			// disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
			// startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
			// initClassName: 'aos-init', // class applied after initialization
			// animatedClassName: 'aos-animate', // class applied on animation
			// useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
			// disableMutationObserver: false, // disables automatic mutations' detections (advanced)
			// debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
			// throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)


			// Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
			// offset: 120, // offset (in px) from the original trigger point
			// delay: 0, // values from 0 to 3000, with step 50ms
			duration: 1000, // values from 0 to 3000, with step 50ms
			// easing: 'ease', // default easing for AOS animations
			once: true, // whether animation should happen only once - while scrolling down
			// mirror: false, // whether elements should animate out while scrolling past them
			// anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

		});

		// init ScrollMagic controller
		var controller = new ScrollMagic.Controller();

		$('.sections .section').each(function(){
		 // Create a scene for each project
		 var section = this;
		 var preSection = $(section).prev();
		 var myScene = new ScrollMagic.Scene({
		 	triggerElement: this,
		 	triggerHook: 0.5
		 })
		 .on("enter", function (e) {
	 		$('.bw-featured-scroll-sections .devices img:nth-child('+$(section).data('index')+')').addClass('fade-in');
	 		root.style.setProperty('--background-color', $(section).data('background-color'));
	 		root.style.setProperty('--text-color', $(section).data('text-color'));
	 	 })
	 	 .on("leave", function (e) {
	 	  $('.bw-featured-scroll-sections .devices img:nth-child('+$(section).data('index')+')').removeClass('fade-in');
	 	 })
	 	 .on("progress", function (event) {
	 	     if ( event.state == 'BEFORE' && event.scrollDirection == 'REVERSE') {
	 	     	if ( preSection.length ) {
	 	     		root.style.setProperty('--background-color', $(preSection).data('background-color'));
	 	     		root.style.setProperty('--text-color', $(preSection).data('text-color'));
	 	     	} else {
	 	     		root.style.setProperty('--background-color', '');
	 	     		root.style.setProperty('--text-color', '');
	 	     	}
	 	     }
	 	 })
		 .addTo(controller);
		});

		function initLogoLists() {
			var logoLists = $('.bw-logo-list');

			if ( logoLists.length ) {
				$('.logo-carousel:not(.slick-initialized)', logoLists).slick( {
					infinite: true,
					dots: false,
					arrows: false,
					mobileFirst: true,
					variableWidth: true,
					centerMode: true,
					slidesToScroll: 1,
					// speed: 150,
					autoplay: true,
					autoplaySpeed: 3000,
					responsive: [
					    {
					      breakpoint: 768,
					      settings: "unslick"
					    }
					]
				});
			}
		}

		initLogoLists();

		var advisorsCarousel = $('.bw-advisors-carousel');

		if ( advisorsCarousel.length ) {
			$('.carousel:not(.slick-initialized)', advisorsCarousel).slick( {
				infinite: true,
				dots: true,
				arrows: false,
				mobileFirst: true,
				slidesToScroll: 1,
				// speed: 150,
				autoplay: true,
				autoplaySpeed: 3000,
				fade: true,
				cssEase: 'ease-in-out'
			});
		}

		var pricingTable = $('.bw-pricing-table');

		if ( pricingTable.length ) {
			$('.pricing-table:not(.slick-initialized)', pricingTable).slick( {
				infinite: false,
				dots: true,
				arrows: false,
				mobileFirst: true,
				slidesToScroll: 1,
				slidesToShow: 1,
				responsive: [
				    {
				      breakpoint: 1024,
				      settings: {
				      	slidesToShow: 3,
				      	dots: false
				      }
				    },
				    {
				      breakpoint: 768,
				      settings: {
				      	slidesToShow: 2,
				      }
				    }
				]
			});
		}

		var bodyBlackout = $('.body-blackout');

		$('.popup-trigger').on('click', function(e) {
			var popup = $(this).data('popup-trigger');
			triggerPopup(popup);
		});

		function triggerPopup( popup ) {
			var popupModal = $('[data-popup-modal="'+popup+'"]');

			if ( !popupModal.length ) {
				return false;
			}

			popupModal.addClass('is--visible');
			bodyBlackout.addClass('is-blacked-out');

			$('.popup-modal__close', popupModal).add(bodyBlackout).on('click', function(e) {
				popupModal.removeClass('is--visible');
				bodyBlackout.removeClass('is-blacked-out');
				popupModal.trigger('popup-closed');
			});
		}

		var getAccess = getCookie('get_updates');

		if ( !getAccess ) {
			setTimeout( function() {
				triggerPopup('get-updates');
			}, 5000);
		}

		$('#get-updates').on( 'popup-closed', function(e) {
			document.cookie = "get_updates=1; path=/; SameSite=Strict";
		});

		$(document).on('gform_confirmation_loaded', function(event, formId){
			if ( formId == 2 ) {
				document.cookie = "get_updates=1; path=/; SameSite=Strict";
			}
	    });
		
		window.addEventListener( 'resize', function() {
			if ( window.innerWidth < 769 ) {
				initLogoLists();
			}
		});

	});
	
});